<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <div class="featureFormContent">
      <v-row class="mb-4">
        <v-col>
          <VTextField
            v-model="formData.key"
            :label="$t('features.headers.module')"
            :rules="{ required: true}"
            outlined
            readonly
            data-cy="featureForm-key"
            required
          />
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col>
          <VTextField
            v-model="formData.type"
            :label="$t('features.headers.submodule')"
            :rules="{required: true}"
            outlined
            readonly
            data-cy="featureForm-type"
            required
          />
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col>
          <VTextarea
            v-model="formData.description[selectedLang]"
            :label="$t(`forms.labels.description_${selectedLang}`)"
            :rules="{ min: 1, max: 3000 }"
            outlined
            :data-cy="'featureForm-description-' + selectedLang"
            required
          />
        </v-col>
      </v-row>

      <!-- Add other fields as necessary with similar structure -->

      <!-- Emit validation states -->
      <SlotScopeWatcher
        :value="dirty"
        @change="$emit('dirtyChanged', dirty)"
      />
      <SlotScopeWatcher
        :value="valid"
        @change="$emit('validChanged', valid)"
      />
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';

export default {
    name: 'FeatureForm',
    components: {
        ValidationObserver,
        VTextField,
        VTextarea,
        SlotScopeWatcher,
    },
    props: {
        feature: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                key: '',
                type: '',
                description: {},
                // Add other fields as necessary
            },
        };
    },
    computed: {
        ...mapGetters(['selectedLang']),
    },
    watch: {
        feature: {
            handler(newFeature) {
                this.formData = {
                    ...newFeature,
                    description: { ...(newFeature.description || {}) },
                };
            },
            immediate: true,
            deep: true,
        },
        formData: {
            handler() {
                this.emitFormData();
            },
            deep: true,
        },
    },
    methods: {
        emitFormData() {
            this.$emit('sendData', { ...this.formData });
        },
    },
};
</script>

<style scoped lang="scss">
.featureFormContent {
  padding: 20px;
}

@media screen and (max-width: 992px) {
  .featureFormContent {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 600px) {
  .featureFormContent {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

/* Add any additional styles as necessary */
</style>
